(function( $, window, document, undefined) {

    var Accordion = {
        init: function init(elem) {
            this.$elem = $( elem );
            this.$content = this.$elem.find('.accordion__content');
            this.$wrapper = this.$elem.find('.accordion__wrapper');
            this.loaded = false;

            this.events();
            this.render();
        },

        open: function open(index) {
            var wrapperHeight = this.$wrapper.outerHeight();

            this.$elem.addClass('is-open');
            this.$content.css({ 'max-height': wrapperHeight + 'px' })
        },

        close: function close(index) {
            this.$elem.removeClass('is-open');
            this.$content.css({ 'max-height': '0px' })
        },

        events: function events() {
            var that = this;

            this.$elem.on('click', '.accordion__header', function(event) {
                if (that.$elem.hasClass('is-open')) {
                    that.close()
                } else {
                    that.open();
                }

                event.preventDefault();
            });
        },

        render: function render() {
            if (this.$elem.hasClass('is-open')) {
                return this.open();
            }

            this.close();
        }
    };

    $.fn.accordion = function( options ) {
        return this.each(function() {
            var accordionObj = Object.create( Accordion );
            accordionObj.init(this);
        });
    };

})( jQuery, window, document );
